import "./Footer.css";
function Footer() {
    return (
        <footer className="footer-wrapper">
            <div className="container-lg container-fluid-sm">
                <div className="upper-text-container">
                    1. Offer valid on qualifying purchases of eligible Apple
                    products from November 25, 2022, to November 28, 2022, at a
                    qualifying location. Offer subject to availability. While
                    supplies last. Customers shall receive a discount equal to
                    the value of the Promotion Product (depending on their
                    purchase) off the price of the Eligible Product, but will be
                    charged for all items in their cart. Important notice
                    regarding the checkout receipt and monthly statement for
                    Apple Card Monthly Installment (ACMI) purchases with this
                    promotion: A purchase of an Eligible Product made when
                    selecting ACMI (a 0% APR payment option available only in
                    the U.S.) as the payment type at checkout will receive an
                    instant credit equal to the cost of the Promotion Product
                    (Apple Gift Card) deducted from the price of the Eligible
                    Product at the time of purchase. You will be charged one
                    ACMI installment plan for the Eligible Product discounted by
                    the instant credit. The value of the Promotion Product (i.e.
                    the value of the Apple Gift Card) will also be charged in a
                    separate second ACMI installment plan for the same number of
                    months as the discounted Eligible Product. The total
                    combined amount charged over the 2 separate ACMI installment
                    plans will reflect the original full retail price of the
                    Eligible Product. Separately, you will receive and be
                    charged for the Promotion Product (Apple Gift Card) in the
                    amount of the applicable instant credit. ACMI is subject to
                    credit approval and credit limit. Variable APRs for Apple
                    Card other than ACMI range from 13.99% to 24.99% based on
                    creditworthiness. Rates as of October 1, 2022. If you choose
                    the pay-in-full or one-time-payment option for an
                    ACMI-eligible purchase instead of choosing ACMI as the
                    payment option at checkout, that purchase will be subject to
                    the variable APR assigned to your Apple Card. Taxes and
                    shipping are not included in ACMI transactions and are
                    subject to your standard purchase APR. See the Apple Card
                    Customer Agreement at
                    <a href="https://www.goldmansachs.com/terms-and-conditions/Apple-Card-Customer-Agreement.pdf">
                        https://www.goldmansachs.com/terms-and-conditions/Apple-Card-Customer-Agreement.pdf
                    </a>
                    for more information. ACMI is not available for purchases
                    made online at the following special stores: Apple Employee
                    Purchase Plan; participating corporate Employee Purchase
                    Programs; Apple at Work for small businesses; Government,
                    and Veterans and Military Purchase Programs, or on
                    refurbished devices. iPhone activation required on iPhone
                    purchases made at an Apple Store with one of these national
                    carriers: AT&T, Sprint, Verizon, or T-Mobile. Apple Card is
                    issued by Goldman Sachs Bank USA, Salt Lake City Branch.
                    Available for qualifying applicants in the United States. If
                    you reside in the U.S. territories, please call Goldman
                    Sachs at 877-255-5923 with questions about accessing this
                    offer or applying for Apple Card. Except for ACMI, this
                    offer cannot be combined with other Apple promotion(s) or
                    financing offers that are directed to individual end-user
                    customers in the qualifying location. This offer also cannot
                    be combined with the Apple Employee Purchase Plan or
                    business loyalty pricing. Some method of payment types are
                    not accepted under this offer. See checkout for details.
                    Availability of in-store promotion offerings may be limited
                    by Apple Store location closures as a result of COVID-19.
                    Additional restrictions apply. View full terms and
                    conditions of offer
                    <a href="https://www.apple.com/shop/gifts/shopping-event/terms-conditions">
                        here
                    </a>
                    . <br />
                    <br />
                    To access and use all the features of Apple Card, you must
                    add Apple Card to Wallet on an iPhone or iPad with the
                    latest version of iOS or iPadOS. Update to the latest
                    version by going to Settings `{">"}` General `{">"}`
                    Software Update. Tap Download and Install. <br />
                    <br />
                    Available for qualifying applicants in the United States.
                    <br />
                    <br />
                    Apple Card is issued by Goldman Sachs Bank USA, Salt Lake
                    City Branch. <br />
                    <br />
                    Learn more about how Apple Card applications are evaluated
                    at
                    <a href="https://support.apple.com/en-us/HT209218">
                        support.apple.com/kb/HT209218
                    </a>
                    .
                </div>
                <div className="footer-links-wrapper row">
                    <div className="links-wrapper-1 col-sm-12 col-md">
                        <h3>Shop and Learn</h3>
                        <ul>
                            <li>
                                <a href="https://www.apple.com/us/shop/goto/store">
                                    Store
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/mac/">Mac</a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/ipad/">iPad</a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/iphone/">
                                    iPhone
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/watch/">Watch</a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/airpods/">
                                    Airpods
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/tv-home/">
                                    TV & Home
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/airtag/">
                                    AirTag
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/us/shop/goto/buy_accessories">
                                    Accessories
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/us/shop/goto/giftcards">
                                    Gift Cards
                                </a>
                            </li>
                        </ul>
                        <h3>Apple Wallet</h3>
                        <ul>
                            <li>
                                <a href="https://www.apple.com/wallet/">
                                    Wallet
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-card/">
                                    Apple Card
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-pay/">
                                    Apple Pay
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-cash/">
                                    Apple Cash
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="links-wrapper-2 col-sm-12 col-md">
                        <h3>Account</h3>
                        <ul>
                            <li>
                                <a href="https://appleid.apple.com/us/">
                                    Manage Your Apple ID
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/us/shop/goto/account">
                                    Apple Store Account
                                </a>
                            </li>
                            <li>
                                <a href="https://www.icloud.com/">iCloud.com</a>
                            </li>
                        </ul>
                        <h3>Entertainment</h3>
                        <ul>
                            <li>
                                <a href="https://www.apple.com/apple-one/">
                                    Apple One
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-tv-plus/">
                                    Apple TV+
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-music/">
                                    Apple Music
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-arcade/">
                                    Apple Arcade
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-fitness-plus/">
                                    Apple Fitness+
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-news/">
                                    Apple News+
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-podcasts/">
                                    Apple Podcasts
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/apple-books/">
                                    Apple Books
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/app-store/">
                                    App Store
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="links-wrapper-3 col-sm-12 col-md">
                        <h3>Apple Store</h3>
                        <ul>
                            <li>
                                <a href="">Find a Store </a>
                            </li>
                            <li>
                                <a href="">Genius Bar </a>
                            </li>
                            <li>
                                <a href="">Today at Apple</a>
                            </li>
                            <li>
                                <a href="">Apple Camp</a>
                            </li>
                            <li>
                                <a href="">Apple Store App</a>
                            </li>
                            <li>
                                <a href="">Certified Refurbished </a>
                            </li>
                            <li>
                                <a href="">Financing</a>
                            </li>
                            <li>
                                <a href="">Apple Trade In</a>
                            </li>
                            <li>
                                <a href="">Order Status</a>
                            </li>
                            <li>
                                <a href="">Shopping Help</a>
                            </li>
                        </ul>
                    </div>
                    <div className="links-wrapper-4 col-sm-12 col-md">
                        <h3>For Business</h3>
                        <ul>
                            <li>
                                <a href="">Apple and Business</a>
                            </li>
                            <li>
                                <a href="">Shop for Business</a>
                            </li>
                        </ul>
                        <h3>For Education</h3>
                        <ul>
                            <li>
                                <a href="">Apple and Education</a>
                            </li>
                            <li>
                                <a href="">Shop for K-12</a>
                            </li>
                            <li>
                                <a href="">Shop for College</a>
                            </li>
                        </ul>
                        <h3>For Healthcare</h3>
                        <ul>
                            <li>
                                <a href="">Apple in Healthcare</a>
                            </li>
                            <li>
                                <a href="">Health on Apple Watch</a>
                            </li>
                            <li>
                                <a href="">Health Records on iPhone</a>
                            </li>
                        </ul>
                        <h3>For Government</h3>
                        <ul>
                            <li>
                                <a href="">Shop for Government</a>
                            </li>
                            <li>
                                <a href="">Shop for Veterans and Military</a>
                            </li>
                        </ul>
                    </div>
                    <div className="links-wrapper-5 col-sm-12 col-md">
                        <h3>Apple Values</h3>
                        <ul>
                            <li>
                                <a href="">Accessibility</a>
                            </li>
                            <li>
                                <a href="">Education</a>
                            </li>
                            <li>
                                <a href="">Environment</a>
                            </li>
                            <li>
                                <a href="">Inclusion and Diversity</a>
                            </li>
                            <li>
                                <a href="">Privacy</a>
                            </li>
                            <li>
                                <a href="">Racial Equity and Justice</a>
                            </li>
                            <li>
                                <a href="">Supplier Responsibility</a>
                            </li>
                        </ul>
                        <h3>About Apple</h3>
                        <ul>
                            <li>
                                <a href="">Newsroom</a>
                            </li>
                            <li>
                                <a href="">Apple Leadership</a>
                            </li>
                            <li>
                                <a href="">Career Opportunities</a>
                            </li>
                            <li>
                                <a href="">Investors</a>
                            </li>
                            <li>
                                <a href="">Ethics & Compliance</a>
                            </li>
                            <li>
                                <a href="">Events</a>
                            </li>
                            <li>
                                <a href="">Contact Apple</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="my-apple-wrapper">
                    More ways to shop:
                    <a href="https://www.apple.com/retail/">
                        Find an Apple Store
                    </a>
                    or
                    <a href="https://locate.apple.com/">other retailer</a>
                    near you. Or call 1-800-MY-APPLE.
                </div>
                <div className="copyright-wrapper row">
                    <div className="copyright col-sm-12 order-2 col-md-8 order-md-1 col-lg-4 order-lg-1">
                        Copyright © 2022 Apple Inc. All rights reserved.
                    </div>
                    <div className="footer-links-terms col-sm-12 order-3 col-lg-6 order-lg-2">
                        <ul>
                            <li className="privacyPolicy">
                                <a href="https://www.apple.com/legal/privacy/">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/legal/internet-services/terms/site.html">
                                    Terms of Use
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/us/shop/goto/help/sales_refunds">
                                    Sales and Refunds
                                </a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/legal/">Legal</a>
                            </li>
                            <li>
                                <a href="https://www.apple.com/sitemap/">
                                    Site Map
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-country col-sm-12 order-1 col-md-4 order-md-2 text-md-right col-lg-2 order-lg-3">
                        <a href="https://www.apple.com/choose-country-region/">
                            United States
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
